import { sendData } from '../helpers/network';
import { ContactFormRequestDataWithReCaptcha } from "../types/contact-form";


const contactAPI = {
  sendForm: (data: ContactFormRequestDataWithReCaptcha) => sendData('/feedback', data),
}

export default contactAPI;